import { render, staticRenderFns } from "./configSoftwareForm.vue?vue&type=template&id=03579fd0&scoped=true&"
import script from "./configSoftwareForm.vue?vue&type=script&lang=js&"
export * from "./configSoftwareForm.vue?vue&type=script&lang=js&"
import style0 from "./configSoftwareForm.vue?vue&type=style&index=0&id=03579fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03579fd0",
  null
  
)

export default component.exports